import React from 'react';

function NotFound() {
    return (
        <div>
            Ruta no encontrada
        </div>
    )
}

export default NotFound;
